import { RentalStatus } from 'src/models/rental/enums/RentalStatus'
import { ReservationStatus } from 'src/models/reservation/enums/ReservationStatus'

export type OrderItemStatus =
  | RentalStatus
  | ReservationStatus
  | DerivedReservationStatus

export enum DerivedReservationStatus {
  STATUS_EXPIRED = 'expired',
}

export const OrderItemStatus = {
  RentalStatus,
  ReservationStatus,
  DerivedReservationStatus,
} as const
